import React from 'react'

function GoogleMap() {
  return (
    <div>
          <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <iframe className="iframe-fluid" height="410" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=AQUA%20DIMON%20R.O%20SYSTEM%20OFFICE,%20462P+RH9,%20uttarpara%20more,%20Radharghat,%20Berhampore,%20West%20Bengal%20742187%20+(AQUA%20DIMON%20R.O%20SYSTEM%20OFFICE,%20462P+RH9,%20uttarpara%20more,%20Radharghat,%20Berhampore,%20West%20Bengal%20742187)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default GoogleMap